import useWishlistOverview from './useWishlistOverview';

export default function useActiveWishlistId() {
  const { wishlists } = useWishlistOverview();
  const active = wishlists?.find(wishlist => wishlist.active);

  return active ? active.id : null;
}
